import React from 'react';
import { Modal, ModalDialog, Typography, Box } from '@mui/joy';
import { format, parseISO } from 'date-fns';

interface SignatureModalProps {
  open: boolean;
  onClose: () => void;
  signatureData: string;
  action: 'checkin' | 'checkout';
  timestamp: string;
  parentName?: string;
}

const SignatureModal: React.FC<SignatureModalProps> = ({
  open,
  onClose,
  signatureData,
  action,
  timestamp,
  parentName,
}) => {
  const formatTimestamp = (timestamp: string) => {
    if (!timestamp) {
      return 'No timestamp available';
    }

    try {
      // First try parsing as ISO string
      const date = parseISO(timestamp);
      if (isNaN(date.getTime())) {
        // If ISO parsing fails, try parsing as a number (Unix timestamp)
        const unixDate = new Date(Number(timestamp));
        if (isNaN(unixDate.getTime())) {
          return 'Invalid timestamp';
        }
        return format(unixDate, "MM/dd/yyyy h:mm a");
      }
      return format(date, "MM/dd/yyyy h:mm a");
    } catch (error) {
      console.error('Error formatting timestamp:', error);
      return 'Invalid timestamp';
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        sx={{
          maxWidth: 500,
          width: '100%',
        }}
      >
        <Typography level="h4" mb={2}>
          {action.charAt(0).toUpperCase() + action.slice(1)} Signature
        </Typography>
        <Typography level="body-sm" mb={1}>
          Signed at: {formatTimestamp(timestamp)}
        </Typography>
        {parentName && (
          <Typography level="body-sm" mb={2}>
            Signed by: {parentName}
          </Typography>
        )}
        <Box
          sx={{
            width: '100%',
            height: 200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'background.level2',
            borderRadius: 'sm',
            overflow: 'hidden',
          }}
        >
          <img
            src={signatureData}
            alt="Signature"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default SignatureModal; 